import React, { CSSProperties, memo, useMemo } from 'react';
import classNames from 'classnames';
import styles from './QueuePanel.module.scss';
import { TicketStatus } from '../../../types/enums';
import { splitText } from '../../../utils/QueuePage/splitSting';
import { QueueArrowIcon } from '../../../assets/svgComponents/QueueArrowIcon';
import { isQueueScreenDarkTheme } from '../../../constants/API';
import type { MonitorUnitType } from './QueuePanel';

type QueueTicketItemProps = {
  item: MonitorUnitType;
  queueTextStyles?: CSSProperties;
  queueNumberBoxStyles?: CSSProperties;
  ticketFontSize?: string;
  windowFontLarge?: string;
  windowFontMiddle?: string;
  windowFontSmall?: string;
  itemRef?: React.Ref<HTMLDivElement>;
};

const QueueTicketItemComponent = ({
  item,
  queueTextStyles,
  queueNumberBoxStyles,
  ticketFontSize,
  windowFontLarge,
  windowFontMiddle,
  windowFontSmall,
  itemRef
}: QueueTicketItemProps) => {
  const isBlinking = item.status !== TicketStatus.TakeInWorking;
  const windowParts = useMemo(() => splitText(item.window) ?? [], [item.window]);
  const partsCount = windowParts.length;

  return (
    <div ref={itemRef} className={styles.itemQueue}>
      <div
        className={classNames(styles.ticket, {
          [styles.ticketBlinkBG]: isBlinking,
          [styles.longTicketName]: item.itemName.length > 4
        })}
        style={queueNumberBoxStyles}
      >
        <span
          style={
            ticketFontSize
              ? { ...queueTextStyles, fontSize: ticketFontSize }
              : queueTextStyles
          }
        >
          {item.itemName}
        </span>
      </div>
      <QueueArrowIcon />
      <div
        className={classNames(styles.post, {
          [styles.postDarkTheme]: isQueueScreenDarkTheme
        })}
      >
        {windowParts.map((el, index) => {
          const resolvedFontSize =
            el.length < 7
              ? windowFontLarge
              : partsCount === 1 && el.length > 6
                ? windowFontMiddle
                : windowFontSmall;
          return (
            <span
              className={classNames(styles.nowrap, {
                [styles.sizeLarge]: el.length < 7,
                [styles.sizeMiddle]: partsCount === 1 && el.length > 6,
                [styles.sizeSmall]: partsCount > 1
              })}
              style={
                resolvedFontSize
                  ? { ...queueTextStyles, fontSize: resolvedFontSize }
                  : queueTextStyles
              }
              key={index + 1}
            >
              {el}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export const QueueTicketItem = memo(QueueTicketItemComponent);
